export default "__VITE_ASSET__452c130c__"